module.exports = __webpack_public_path__ + "static/cta-moc-1-1-ee591f0c20233b6a5edee01ccbea420d.png";